"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSwitcher = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icons = _interopRequireDefault(require("./LangIcons/Icons"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.language-switcher {\n  width: 3rem;\n  position: relative;\n  z-index: 1; }\n  .language-switcher:hover {\n    cursor: pointer; }\n  .language-switcher img.bx--col-lg-12.bx--col-md-0.bx--col-sm-0,\n  .language-switcher img.bx--col-lg-0.bx--col-md-8.bx--col-sm-4 {\n    margin: 0;\n    padding: 0; }\n  .language-switcher img.bx--col-md-8 {\n    flex: none; }\n  .language-switcher img.bx--col-lg-12.bx--col-md-0.bx--col-sm-0 {\n    width: 2rem; }\n  .language-switcher img.bx--col-lg-0.bx--col-md-8.bx--col-sm-4 {\n    width: 20px; }\n  .language-switcher .chosen-language {\n    width: 3rem;\n    height: 3rem;\n    display: flex;\n    justify-content: center;\n    align-items: center; }\n  .language-switcher .choosable-languages {\n    position: absolute;\n    top: 45px;\n    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.3);\n    background: white; }\n    .language-switcher .choosable-languages .choosable-language {\n      width: 3rem;\n      height: 3rem;\n      display: flex;\n      align-items: center;\n      justify-content: center; }\n      .language-switcher .choosable-languages .choosable-language:hover {\n        background: #e8e8e8; }\n  @media (max-width: 1055px) {\n    .language-switcher .choosable-languages {\n      width: 2rem;\n      left: 0.5rem;\n      top: 36px; }\n      .language-switcher .choosable-languages .choosable-language {\n        width: 2rem;\n        height: 2rem; } }\n";
  const fileName = "LanguageSwitcher_LanguageSwitcher";
  const element = document.querySelector("style[data-sass-component='LanguageSwitcher_LanguageSwitcher']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const LanguageSwitcher = props => {
  const availableLanguages = props.availableLanguages || ['de', 'fr', 'it', 'en'];
  const onChangeLanguage = languageKey => {
    props.onChange(languageKey);
    props.toggle();
  };
  const renderDropdown = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'chosen-language',
      onClick: props.toggle
    }, _Icons.default.chosenLanguage.large[props.selectedLanguageKey], _Icons.default.chosenLanguage.small[props.selectedLanguageKey]);
  };
  const renderOptions = () => {
    if (!props.isOpen) {
      return;
    }
    const relevantLanguageKeys = availableLanguages.filter(languageKey => languageKey !== props.selectedLanguageKey);
    const renderedIcons = relevantLanguageKeys.map(languageKey => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: languageKey,
        className: 'choosable-language',
        onClick: () => onChangeLanguage(languageKey)
      }, _Icons.default.choosableLanguage.large[languageKey], _Icons.default.choosableLanguage.small[languageKey]);
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'choosable-languages'
    }, renderedIcons);
  };
  return availableLanguages.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: 'language-switcher'
  }, renderDropdown(), renderOptions());
};
exports.LanguageSwitcher = LanguageSwitcher;
LanguageSwitcher.propTypes = {
  selectedLanguageKey: _propTypes.default.string.isRequired,
  isOpen: _propTypes.default.bool.isRequired,
  toggle: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired,
  availableLanguages: _propTypes.default.arrayOf(_propTypes.default.string)
};